/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 91bea3268d1c4691912d52ca9d6840c972076fbd0d467b3c4f271b7bb9b9a7b6
 */
import {
  overlay_backgroundBase,
  white100,
} from 'ext-ui/style/colors'
import {
  cornerRadius,
  spacing,
} from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_size_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  background-color: ${overlay_backgroundBase};
  border-radius: ${cornerRadius};
  color: ${white100};
  display: flex;
  font-family: ${font_family_weight_regular};
  font-size: ${font_size_sm};
  font-family: ${font_family_weight_medium};
  line-height: 16px;
  max-width: 200px;
  padding: ${spacing(3)};
  position: relative;
  text-shadow: 0px 3px 10px rgba(0,0,0,0.1);
  word-break: break-word;

  &.showCarrot::before {
    content: '';
    border-color: ${overlay_backgroundBase};
    border-style: solid;
    border-width: ${spacing(2)};
    position: absolute;
  }

  &.top::before,
  &.top-start::before,
  &.top-end::before {
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-right-color: transparent;
    top: 100%;
  }

  &.top::before {
    left: 50%;
    margin-left: -${spacing(2)};
  }

  &.top-start::before {
    left: ${spacing(3)};
  }

  &.top-end::before {
    right: ${spacing(3)};
  }

  &.bottom::before,
  &.bottom-start::before,
  &.bottom-end::before {
    border-left-color: transparent;
    border-right-color: transparent;
    border-top-color: transparent;
    bottom: 100%;
  }

  &.bottom::before {
    left: 50%;
    margin-left: -${spacing(2)};
  }

  &.bottom-start::before {
    left: ${spacing(3)};
  }

  &.bottom-end::before {
    right: ${spacing(3)};
  }

  &.left::before,
  &.left-start::before,
  &.left-end::before {
    border-bottom-color: transparent;
    border-right-color: transparent;
    border-top-color: transparent;
    left: 100%;
  }

  &.left::before {
    margin-top: -${spacing(2)};
    top: 50%;
  }

  &.left-start::before {
    top: ${spacing(3)};
  }

  &.left-end::before {
    bottom: ${spacing(3)};
  }

  &.right::before,
  &.right-start::before,
  &.right-end::before {
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-top-color: transparent;
    right: 100%;
  }

  &.right::before {
    margin-top: -${spacing(2)};
    top: 50%;
  }

  &.right-start::before {
    top: ${spacing(3)};
  }

  &.right-end::before {
    bottom: ${spacing(3)};
  }
`
